// Ressentis de la Partie 1 — libellés féminin (canonique, envoyé au moteur) / masculin (affichage)
// Icônes : fille par défaut ; garçon dans /feelings/garcon/ (repli automatique sur l'icône fille si absente)
export const FEELINGS = [
  { f: "Fatiguée", m: "Fatigué", icon: "/feelings/fatiguee.webp", iconM: "/feelings/garcon/fatigue.webp" },
  { f: "Stressée", m: "Stressé", icon: "/feelings/stressee.webp", iconM: "/feelings/garcon/stresse.webp" },
  { f: "Surchargée", m: "Surchargé", icon: "/feelings/surchargee.webp", iconM: "/feelings/garcon/surcharge.webp" },
  { f: "Tendue", m: "Tendu", icon: "/feelings/tendue.webp", iconM: "/feelings/garcon/tendu.webp" },
  { f: "Dispersée", m: "Dispersé", icon: "/feelings/dispersee.webp", iconM: "/feelings/garcon/disperse.webp" },
  { f: "À fleur de peau", m: "À fleur de peau", icon: "/feelings/fleur.webp", iconM: "/feelings/garcon/fleur.webp" },
  { f: "Je ne sais pas vraiment", m: "Je ne sais pas vraiment", icon: "/feelings/jnsaispas.webp", iconM: "/feelings/garcon/jnsaispas.webp" },
];

export const feelingLabel = (feeling, gender) => (gender === "garçon" ? feeling.m : feeling.f);

export const feelingIcon = (feeling, gender) => (gender === "garçon" ? feeling.iconM : feeling.icon);
